import React, { useEffect, useState } from "react";
import hide from "../../images/hide.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useMutation } from "@apollo/react-hooks";
import { LOGIN } from "../../mutation/login";
import LoginLayout from "./LoginLayout";
import { Link, Redirect, useHistory } from "react-router-dom";
import * as Yup from "yup";
import coolicon from "../../images/coolicon.svg";

const LoginAccount = (props) => {
  const [Login] = useMutation(LOGIN);

  const history = useHistory();

  const [visiblePassword, setVisiblePassword] = React.useState(false);
  const [showResetPasswordSuccess, setShowResetPasswordSuccess] =
    useState(false);

  useEffect(() => {
    let resetPasswordStatus = localStorage.getItem("reset_password_successful");
    if (resetPasswordStatus && resetPasswordStatus === "true") {
      setShowResetPasswordSuccess(true);
      localStorage.setItem("reset_password_successful", "false");
    }

    return () => {
      setShowResetPasswordSuccess(false);
    };
  }, []);

  const resetPasswordAlert = (
    <div className="verify-login">
      <span className="icon">
        <img src={coolicon} alt="right icon" />
      </span>
      <p>Your password has been changed. Sign in again.</p>
    </div>
  );

  const LoginPasswordForm = (
    <LoginLayout>
      <div className="login-cover">
        <div className="login-box">
          <h2>Login</h2>
          {showResetPasswordSuccess ? resetPasswordAlert : null}
          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={Yup.object({
              email: Yup.string()
                .email("Invalid Email Address")
                .required("Please enter your email"),
              password: Yup.string().required("please enter your password"),
            })}
            onSubmit={(values, { setFieldError, setSubmitting }) => {
              Login({
                variables: {
                  email: values.email,
                  password: values.password,
                  full_name: values.fullname,
                  role: "COUNCILER",
                },
              })
                .then((response) => {
                  const {
                    accessToken,
                    refreshToken,
                    data: { userId, profileId },
                  } = response.data.userLogin;
                  localStorage.setItem("jwt_token", accessToken);
                  localStorage.setItem("user_mail", values.email);
                  localStorage.setItem("user_id", userId);
                  if (response?.data?.userLogin?.data?.is_profile_setup) {
                    localStorage.setItem(
                      "is_profile_setup",
                      response?.data?.userLogin?.data?.is_profile_setup
                    );
                  }
                  if (profileId) {
                    localStorage.setItem("profile_id", profileId);
                  }
                  localStorage.setItem("refresh_token", refreshToken);
                  if (!response?.data?.userLogin?.data?.term_and_conditions) {
                    localStorage.setItem(
                      "term_and_conditions",
                      response?.data?.userLogin?.data?.term_and_conditions
                    );
                    localStorage.setItem(
                      "user_profile_role",
                      response?.data?.userLogin?.data?.role
                    );
                  }
                  history.push("/dashboard");
                  setSubmitting(false);
                })
                .catch((e) => {
                  const errors = e.graphQLErrors;
                  if (
                    errors[0] &&
                    errors[0].message &&
                    errors[0].message === "User not found"
                  ) {
                    setFieldError("email", errors[0].message);
                  } else if (
                    (errors[0] && errors[0].message) ||
                    "password must contain one uppercase, lowercase, number and symbol"
                  ) {
                    setFieldError("password", errors[0].message);
                  }
                  setSubmitting(false);
                });
            }}
          >
            {({ isSubmitting }) => (
              <Form className="login-form">
                {/* <div className="form-group">
                            <label>Full Name</label>
                            <Field type="text" name="fullname" className="form-control"/>
                            <ErrorMessage name="fullname" component="div" className="error-message"/>
                        </div> */}
                <div className="form-group">
                  <label>Email</label>
                  <Field className="form-control" type="email" name="email" />
                  <ErrorMessage
                    className="error-message"
                    name="email"
                    component="div"
                  />
                </div>
                <div className="form-group password-row">
                  <label>Password</label>
                  <div className="hide-icon">
                    <Field
                      className="form-control"
                      type={visiblePassword ? "text" : "password"}
                      name="password"
                    />
                    <img
                      alt="password hide"
                      onClick={() => setVisiblePassword(!visiblePassword)}
                      src={hide}
                    />
                  </div>
                  <ErrorMessage
                    className="error-message"
                    name="password"
                    component="div"
                  />

                  {/* <div className="forgot-password">
                                <Link to="/reset-password">Forgot Password</Link>
                            </div> */}
                </div>
                <div className="form-group remeber-row">
                  <label class="checkbox">
                    Remember Me
                    <input type="checkbox" />
                    <span class="checkmark"></span>
                  </label>
                  <div className="forgot-password">
                    <Link to="/reset-password">Forgot Password</Link>
                  </div>
                </div>
                <div className="form-submit">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isSubmitting}
                  >
                    Login
                  </button>
                </div>
                <div className="create-account-link">
                  <p>
                    Not Registered Yet?
                    <Link to="/signup">Create an account</Link>
                  </p>

                  {/* <p>
                    Not Registered Yet? <a href="#">Create an account</a>
                  </p> */}
                </div>
              </Form>
            )}
          </Formik>

          {/* <form className="login-form">
                    <div className="form-group">
                        <label>Full Name</label>
                        <input type="text" className="form-control" />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="Email" className="form-control"/>
                    </div>
                    <div className="form-group">
                        <label>Password</label>  
                        <div className="hide-icon">                  
                            <input type="Password" className="form-control" />                        
                            <img src={hide} alt="password hide"/>
                        </div>
                        <div className="forgot-password">
                            <a href="#">Forgot Password</a>
                        </div>
                    </div>
                    <div className="form-submit">
                        <input type="submit" className="submit-btn" value="Login" />
                    </div>
                </form> */}
        </div>
      </div>
    </LoginLayout>
  );
  if (localStorage.getItem("jwt_token")) {
    if (
      localStorage.getItem("profile_id") &&
      localStorage.getItem("is_profile_setup")
    ) {
      return <Redirect to="/dashboard" />;
    } else {
      return LoginPasswordForm;
    }
  } else {
    return LoginPasswordForm;
  }
};

export default LoginAccount;
